var map = {
	"./advantages-slider/advantages-slider.js": 6651,
	"./advantages-work/advantages-work.js": 5695,
	"./banner/banner.js": 7640,
	"./cities/cities.js": 4733,
	"./contacts-block/contacts-block.js": 4312,
	"./lang/lang.js": 4248,
	"./mobile-menu/mobile-menu.js": 8665,
	"./profitable-proposition/profitable-proposition.js": 9078,
	"./with-us-work/with-us-work.js": 2403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5775;